import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { filter, tap } from 'rxjs/operators';

import { AuthService } from 'src/app/core/services/auth.service';
import { AppSignUpDialogComponent } from 'src/app/shared/modules/sign-up-dialog/components';
import {
  AppleAuthService,
  GoogleAuthService
} from 'src/app/modules/registration/shared/services';
import { RegistrationFacade } from 'src/app/modules/registration/store';

@Component({
  selector: 'app-front-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  suggestedSlideConfig: { [key: string]: any } = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  readonly fields = {
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6)
    ])
  };

  readonly form = this._formBuilder.group(this.fields);

  constructor(
    private readonly _dialog: MatDialog,
    private readonly _formBuilder: FormBuilder,
    private readonly _authService: AuthService,
    private readonly _appleAuthService: AppleAuthService,
    private readonly _googleAuthService: GoogleAuthService,
    private readonly _registrationFacade: RegistrationFacade
  ) {}

  onSignin() {
    this._authService
      .login(this.form.getRawValue())
      .pipe(tap((_) => this._dialog.closeAll()))
      .subscribe();
  }

  onAppleSignin() {
    this._appleAuthService
      .login()
      .pipe(
        filter((_) => !!_),
        tap((_) => this._registrationFacade.appleAuth(_)),
        tap((_) => this._dialog.closeAll())
      )
      .subscribe();
  }

  onGoogleSignin() {
    this._googleAuthService
      .login()
      .pipe(
        filter((_) => !!_),
        tap((_) => this._registrationFacade.googleAuth(_)),
        tap((_) => this._dialog.closeAll())
      )
      .subscribe();
  }

  onStudent() {
    return this._dialog.open(AppSignUpDialogComponent, {
      autoFocus: false,
      data: {
        accountType: 'student'
      }
    });
  }

  onEducator() {
    return this._dialog.open(AppSignUpDialogComponent, {
      autoFocus: false,
      data: {
        accountType: 'teacher'
      }
    });
  }

  onOrganization() {
    return this._dialog.open(AppSignUpDialogComponent, {
      autoFocus: false,
      data: {
        accountType: 'org'
      }
    });
  }

  onGetStarted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
